// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const UPLOADING_PHOTOS = "Nahr\u00e1v\u00e1n\u00ed fotek";
